var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "marketplaceFooter" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "marketplaceFooter_main" }, [
        _c("div", { staticClass: "marketplaceFooter_main_section" }, [
          _c(
            "div",
            { staticClass: "marketplaceFooter_logomark" },
            [_c("pickstar-logomark")],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.menus.general_links && _vm.menus.general_links.length
          ? _c("div", { staticClass: "marketplaceFooter_main_section" }, [
              _c("h3", { staticClass: "marketplaceFooter_heading" }, [
                _vm._v("Pickstar"),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "marketplaceFooter_generalNav" },
                _vm._l(_vm.menus.general_links, function (item, index) {
                  return _c("li", { key: index }, [
                    _c("a", { attrs: { href: item.link } }, [
                      _vm._v(_vm._s(item.label)),
                    ]),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.regionInfo
          ? _c("div", { staticClass: "marketplaceFooter_main_section" }, [
              _c("h3", { staticClass: "marketplaceFooter_heading" }, [
                _vm._v(_vm._s(_vm.regionInfo.name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "marketplaceFooter_office" }, [
                _vm.regionInfo.address
                  ? _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.nl2br(_vm.regionInfo.address)
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.regionInfo.phone
                  ? _c(
                      "div",
                      { staticClass: "marketplaceFooter_contactItem" },
                      [
                        _c(
                          "a",
                          { attrs: { href: `tel:${_vm.regionInfo.phone}` } },
                          [
                            _c("i", { staticClass: "fa fa-phone" }),
                            _vm._v(" " + _vm._s(_vm.regionInfo.phone)),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.regionInfo.from_email
                  ? _c(
                      "div",
                      { staticClass: "marketplaceFooter_contactItem" },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: `mailto:${_vm.regionInfo.from_email}`,
                            },
                          },
                          [
                            _c("i", { staticClass: "fa fa-at" }),
                            _vm._v(" " + _vm._s(_vm.regionInfo.from_email)),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.menus.social_links && _vm.menus.social_links.length
          ? _c("div", { staticClass: "marketplaceFooter_main_section" }, [
              _c(
                "ul",
                { staticClass: "marketplaceFooter_socials" },
                _vm._l(_vm.menus.social_links, function (item, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass: "marketplaceFooter_socials_link",
                        attrs: {
                          href: item.link,
                          target: "_blank",
                          "aria-label": item.label,
                        },
                      },
                      [_c("i", { class: `fa fa-${item.name}` })]
                    ),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "marketplaceFooter_additional" }, [
        _c("div", { staticClass: "marketplaceFooter_copyright" }, [
          _c("span", [_vm._v("© Copyright " + _vm._s(_vm.year) + " PickStar")]),
          _vm._v(" "),
          _vm.regionInfo && _vm.regionInfo.company_reg
            ? _c("span", [_vm._v(_vm._s(_vm.regionInfo.company_reg))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.menus.legal_links && _vm.menus.legal_links.length
          ? _c(
              "ul",
              { staticClass: "marketplaceFooter_legals" },
              _vm._l(_vm.menus.legal_links, function (item, index) {
                return _c("li", { key: index }, [
                  _c("a", { attrs: { href: item.link } }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }